import type { PopconfirmProps } from 'antd';
import { Popconfirm } from 'antd';
import React from 'react';

const FBPopconfirm: React.FC<PopconfirmProps> = ({ ...rest }) => (
  <Popconfirm
    {...rest}
    okButtonProps={{ 'data-cy': 'pop-confirm-ok', ...rest.okButtonProps }}
  />
);

export default FBPopconfirm;
